import * as React from 'react';
import { Dispatch } from 'react-redux';
import { SharePanelActionKeys, shareItems } from '../../../containers/Share/actions';
import { StoreState } from '../../../reducers';
import { PageOverlay } from '../../PageOverlay/styles';
import {
	StyledSharePanel,
	SharePanelHeader, SharePanelHeaderContainer, SharePanelHeaderTitle, SharePanelHeaderClose,
	SharePanelContent, SharePanelContentContainer,
	SharePanelContentSelection, SharePanelContentSelectionTitle, SharePanelContentSelectionContent,
	SharePanelContentRight, SharePanelContentForm,
	SharePanelContentFormTitle, SharePanelContentFormContent, SharePanelContentFormContentLeft, SharePanelContentFormContentRight,
	ShareButton, ShareInput, ShareInputLast
} from './styles';
import { TextArea } from '../../../components/Form/styles';
import { FormState } from '../../../containers/Share/reducer';
import { Api } from '../../../typings/api';
import DriveItemUtils from '../../../utils/driveItem';
import Utils from '../../../utils';

import { Translate } from 'react-redux-i18n';
const I18n = require('react-redux-i18n').I18n;

interface WebpublicationShareFormProps {
	selectedResources: Api.DriveItem[];
	isOpen: boolean;
	form: FormState;
	dispatch: Dispatch<StoreState>;
	isProcessing: boolean;
}

class WebpublicationShareForm extends React.Component<WebpublicationShareFormProps, {}> {
	constructor(props: WebpublicationShareFormProps) {
		super(props);
		this.closePanel = this.closePanel.bind(this);
		this.handleChangeFormField = this.handleChangeFormField.bind(this);
		this.handleSendForm = this.handleSendForm.bind(this);
	}

	closePanel = () => {
		const { dispatch } = this.props;
		dispatch({ type: SharePanelActionKeys.CLOSE_PANEL });
	}

	handleChangeFormField(name: string) {
		return (e: React.FormEvent<HTMLInputElement> | React.FormEvent<HTMLTextAreaElement>) => {
			const { dispatch } = this.props;
			dispatch(
				{
					type: SharePanelActionKeys.SET_FORM_FIELD,
					name: name,
					value: e.currentTarget.value
				}
			);
		};
	}

	handleSendForm(e: React.FormEvent<HTMLFormElement>) {
		e.preventDefault();
		const { dispatch } = this.props;
		dispatch(shareItems());
	}

	render() {
		const { isOpen } = this.props;

		return (
			<>
				<PageOverlay isOpen={isOpen} onClick={this.closePanel} data-gallery-slot="shareForm" />
				<StyledSharePanel
					isOpen={isOpen}
					data-gallery-slot="shareForm"
				>
					{this.renderHeader()}
					{this.renderContent()}
				</StyledSharePanel>
			</>
		);
	}

	renderHeader() {
		return (
			<SharePanelHeader>
				<SharePanelHeaderContainer>
					<SharePanelHeaderTitle>
						<Translate
							value="messages.share_my_selection"
						/>
					</SharePanelHeaderTitle>
					<SharePanelHeaderClose onClick={this.closePanel}>
						<Translate
							value="messages.close"
						/>
					</SharePanelHeaderClose>
				</SharePanelHeaderContainer>
			</SharePanelHeader>
		);
	}

	renderContent() {
		return (
			<SharePanelContent>
				<SharePanelContentContainer>
					<SharePanelContentSelection>
						<SharePanelContentSelectionTitle>
							<Translate
								value="messages.my_selection"
							/>
						</SharePanelContentSelectionTitle>
						{this.renderSelectionContent()}
					</SharePanelContentSelection>
					<SharePanelContentRight>
						<SharePanelContentForm>
							<SharePanelContentFormTitle>
								<Translate
									value="messages.share_by_email"
								/>
							</SharePanelContentFormTitle>
							<SharePanelContentFormContent
								onSubmit={this.handleSendForm}
							>
								{this.renderFormLeft()}
								{this.renderFormRight()}
							</SharePanelContentFormContent>
						</SharePanelContentForm>
					</SharePanelContentRight>
				</SharePanelContentContainer>
			</SharePanelContent>
		);
	}

	renderSelectionContent() {
		const { selectedResources } = this.props;

		return selectedResources.map(
			(driveItem, index) => (
				<SharePanelContentSelectionContent
					key={index}
				>
					{DriveItemUtils.getDisplayName(driveItem)}
				</SharePanelContentSelectionContent>
			)
		);
	}

	renderFormLeft() {
		const { form } = this.props;
		const { userName, userEmail, contactEmail } = form;

		return (
			<SharePanelContentFormContentLeft>
				<ShareInput
					value={userName}
					onChange={this.handleChangeFormField('userName')}
					placeholder={I18n.t('messages.placeholder_share_name')}
					required={true}
					type="text"
					key="userName"
				/>
				<ShareInput
					value={userEmail}
					onChange={this.handleChangeFormField('userEmail')}
					placeholder={I18n.t('messages.placeholder_share_user_email')}
					required={true}
					type="email"
					key="userEmail"
				/>
				<ShareInputLast
					value={contactEmail}
					onChange={this.handleChangeFormField('contactEmail')}
					placeholder={I18n.t('messages.placeholder_share_contact_email')}
					required={true}
					type="email"
					key="contactEmail"
				/>
			</SharePanelContentFormContentLeft>
		);
	}

	renderFormRight() {
		const { form, isProcessing } = this.props;
		const { message } = form;

		return (
			<SharePanelContentFormContentRight>
				<TextArea
					value={message}
					onChange={this.handleChangeFormField('message')}
					placeholder={I18n.t('messages.placeholder_share_message')}
					required={true}
					key="message"
				/>
				<ShareButton
					type="submit"
					disabled={isProcessing}
				>
					{isProcessing && Utils.getSvgIcon('iconset_loading')}
					<Translate
						value="messages.send_my_selection"
					/>
				</ShareButton>
			</SharePanelContentFormContentRight>
		);
	}
}

export default WebpublicationShareForm;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Share/WebpublicationForm/index.tsx